module.exports = __webpack_public_path__ + "img/account-icon-solid.79f46535.svg";